"use strict";
/**
 * Order Formatting
 * Formatting utilities for order display
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderStatusBadge = getOrderStatusBadge;
/**
 * Get order status badge text and color
 * @param status - Order status
 * @returns Badge text and color
 */
function getOrderStatusBadge(status) {
    const statusMap = {
        pending: { text: "Pending", color: "#FF9500" }, // Orange
        open: { text: "Open", color: "#007AFF" }, // Blue
        partially_filled: { text: "Partial", color: "#34C759" }, // Green
        filled: { text: "Filled", color: "#34C759" }, // Green
        cancelled: { text: "Cancelled", color: "#8E8E93" }, // Gray
        expired: { text: "Expired", color: "#8E8E93" }, // Gray
        failed: { text: "Failed", color: "#FF3B30" }, // Red
    };
    return statusMap[status] || { text: status, color: "#000000" };
}
